/*
 * This file is part of SketchBand.
 * Copyright (C) 2016  Mikael Brockman
 * 
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 * 
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 * 
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

let inspect = x => JSON.stringify(x, null, 2)

let fail = message => {
  throw new Error(message)
}

let deepEqual = (x, y) => JSON.stringify(x) === JSON.stringify(y)

export let test = f => f({
  is: (x, y) => {
    if (!deepEqual(x, y)) {
      fail(`\n\nWanted: ${inspect(y)},\nActual: ${inspect(x)}\n`)
    }
  },
  ok: (value, message = "Assertion failed") => {
    if (!value) fail(message)
  }
})
